import { fieldTypes } from '@constants/constant';
import { environment } from '@environments/environment';
import { Field } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { NEW_POST_CONST } from '@modules/dashboard/components/new-post/newposts/constants';

export const HOME_STRING = {
  ACCEPT: 'Accept',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  IGNORE: 'Ignore',
  COMMENT: 'comment',
  REPLY: 'reply',
  POST_TYPE: 'post',
  POST_CAPS: 'POST',
  UNREAD: 'Unread',
  FOLLOW_REQUESTS: 'Follow Requests',
  AWARDS: 'awards',
  REPLY_TAG: 'reply_tag',
  TOTAL_COMMENTS: 'total-comments',
  SCHEDULE_POST: 'Schedule Post',
  SELECT: 'Select',
  TRUE: 'true',
  FALSE: 'false',
  ALL: 'ALL',
  CANCEL: 'Cancel',
  WANTS_TO_FOLLOW_YOU: 'wants to follow you',
  NO_PENDING_REQUESTS: 'No Pending Requests',
  YOUR_ACCOUNT_IS_SET_TO_PRIVATE:
    "You have set your account to private, so you must accept user's requests to follow you before they can access your content, subscriptions, store, or send you tips and direct messages.",
  POST_WILL_BE_PUBLISHED_AT: ' will be published at:',
  NO_COURSE_AVAILABLE_MEETING_CRITERIA:
    'No available courses meet your filter criteria.',
  APPROPRIATE_CONTENT: 'appropriateContent',
  CONSENT: 'consent',
  YES: 'YES',
  NO: 'NO',
  IGNORE_REQUEST: 'Ignore Request',
  IGNORE_REQUEST_CONFIRMATION: 'Are you sure you want to ignore this request?',
  USER_POLICY_ACCEPTED: 'userPolicyAccepted',
  CREDIT_CARD_VALIDATION_MESSAGE:
    'To use a Credit Card, the transaction amount must be $1.00 or greater.',
  STORE_FEATURE_ITEM:
    'To add items to your Store go to Monetize. To feature a Store item on your profile click the 3-dot icon on the respective item. You can drag items to set the order that fans will see in your store.',
  VIEW: ' View',
  SENT_TIP: 'sent_tip',
  CHATROOM: 'chatroom',
  CHATROOM_TIP: 'chatroom-tip',
  TIP: 'Tip',
  SEND_TIP: 'Send Tip',
  POSTED_BY: 'Posted By',
  DELIGATE: 'DELEGATE',
  AWARD_ACTIVITY: 'award_activity',
  RESOURCE_REPLY: 'resource-reply',
  RESOURCE_COMMENT: 'resource-comment',
  CAP_COMMENT: 'COMMENT',
  CAP_REPLY: 'REPLY',
  CAP_POST: 'POST',
  WELCOME_MESSAGE: 'welcome-message',
  PUBLISH_NOW: 'Publish Now',
  UPDATE: 'Update',
  PRICE: 'Price',
  PRICE_AFTER_FREE_TRIAL: 'Price After Free Trial',
  BILLING_START: 'Billing Starts on:',
  PAY_NOW: 'Pay Now',
  PAY_WITH_WALLET_CREDITS: 'Pay with wallet credits',
  PAY_WITH_CREDIT_CARD: 'Pay with credit card',
  ADD_MORE_WALLET_CREDITS: 'Add more wallet credits using In-App Purchase',
  AFTER_FREE_TRIAL: 'After Free Trial',
  DISCOUNT_CODE_FOR: 'Discount code for ',
  DISCOUNT: 'Discount',
  SAY_SOMETHING: 'Say something...',
  livestream_started: 'livestream_started',
  PAYMENT_SCREEN_SHIPPING_SCREEN: 'shippingScreen',
  PAYMENT_SCREEN_NONE: 'none',
  PAYMENT_SCREEN_PAYMENT: 'payment',
  PAYMENT_SCREEN_CUSTOMIZE_EXPERIENCE: 'customizeExperience',
  PAYMENT_SCREEN_SCHEDULE_EXPERIENCE: 'scheduleExperience',
  PAYMENT_SCREEN_ORDER_PAYMENT: 'orderPayment',
  PAYMENT_SCREEN_MERCHANDISE_INFO: 'merchandiseInfo',
  PAYMENT_SCREEN_EVENT_TICKET_PREVIEW: 'eventTicketPreview',
  PAYMENT_SCREEN_TICKET_CUSTOMER_INFO: 'ticketCustomerInfo',
  USE_YOUR_WALLET_BALANCE: 'Use your Wallet Balance',
  IMPORT_JOB_COMPLETED:'import_job_completed',
  SHIPPING_ADDRESS: 'Shipping Address',
  SHIPPING_ADDRESS_DESCRIPTION: 'Your contribution may include a gift that will be mailed to you.  Please confirm your preferred shipping address.',
  SHIPPING_ADDRESS_REQUIRED: 'Please fill in all required shipping address fields.',
  PAYMENT_SUCCESSFUL_FUNDRAISER: 'You can claim your gift with the Discount Code listed below and sent to your email.',
  FUNDRAISER_CONTRIBUTION_MESSAGE: 'By making this payment, you will be contributing to',
  GIFT_DEFAULT_TITLE: 'Gift',
  PAYMENT_SUCCESS_STEP_1_DESCRIPTION: "Navigate to the gift you've earned in the store and choose your customizations.",
  PAYMENT_SUCCESS_STEP_2_DESCRIPTION: 'Apply your discount code during checkout.',
  PAYMENT_SUCCESS_STEP_3_DESCRIPTION: "Enjoy your complimentary gift!",
  PAYMENT_SUCCESS_STEP_3_TITLE: 'Fundraiser Gift Claimed Successfully',
  PAYMENT_SUCCESS_STEP_3_DESCRIPTION_TEXT: 'Your gift code has been accepted and your item is now complimentary. Taxes and Shipping fees may still apply.',
  CONTINUE_SHOPPING: 'Continue',
  NO_CONTRIBUTION_LEVELS_AVAILABLE: 'No contribution levels available for this fundraiser.',
  PLEASE_SELECT_VALID_CONTRIBUTION_LEVEL: 'Please select a valid contribution level.',
  SCHEDULE: 'Schedule',
  CUSTOMIZE: 'Customize',
  PAYMENT: 'Payment',
  CUSTOMER_INFORMATION: 'Customer Information',
  SHIPPING: 'Shipping',
  CURRENT_WALLET_CREDITS: 'Current Wallet Credits',
  CONTINUE: 'Continue',
  CONTINUE_TO_SCHEDULING: 'Continue to Scheduling',
  SUBSCRIPTION_EXPERIENCE_MERCHANDISE_DISCOUNT_MSG : 'Your redemption codes expire on the date listed. If your plan includes recieving a recurring experience or merchandise item per month, a new redemption code will be sent to you each month. You can also find your codes in <b>Wallet > My Purchase > Subscription Plans</b>.',
  CHATROOM_GROUP_HINT: 'If a Group(s) is selected in this list, only users belonging to that Group will see this post in the Chat Room.',
  SELECT_RELATED_TOPICS: 'Select Related Topics'
};

export const ICON_CLASS = {
  VERIFIED: 'icon-liteverified'
};

export const COMMENT_VIDEO = {
  ACCEPT_TYPES:
    '.png, .jpg, .jpeg, .gif, .heic, .heif, .webp, .avif, .webm, .mp4, .mov, .MOV',
  ERRORS: {
    MAX_SIZE: 'Video size cannot be more than 200 MB.'
  },
  TRIM_MODAL: {
    CLASS: 'video-trim-modal'
  },
  POSTER: {
    FILE_PREFIX: 'cover_',
    FILE_EXTENSION: 'png',
    MIME_TYPE: 'image/png'
  },
  UPLOAD_STATUS: {
    SELECTED: 'selected',
    UPLOADING: 'uploading',
    COMPLETED: 'completed'
  },
  PREVIEW: {
    ALT: 'Video preview',
    PORTRAIT_WIDTH: 180,
    LANDSCAPE_WIDTH: 320
  },
  labels: {
    PLAY: 'Play'
  }
} as const;

export const COMMENT_IMAGE = {
  /** Compressor options: caps the resolution and always re-encodes PNGs to JPEG. */
  COMPRESSION: {
    maxWidth: 1600,
    maxHeight: 1600,
    convertSize: 0
  }
} as const;

export const STORE_CONSTANTS = {
  REMOVE_FROM_PROFILE: 'Unfeature from Profile',
  FEATURE_ON_PROFILE: 'Feature on Profile',
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  DEFAULT_DOWNLOAD_FILE_NAME: 'Downloadable'
};

export const NEW_POST_MESSAGES = {
  APPROPRIATE_GENERAL_MESSAGE:
    'This content could be considered sensitive by others.',
  APPROPRIATE_IMAGE: 'This content could be considered sensitive by others.',
  APPROPRIATE_VIDEO: 'This content could be considered sensitive by others.',
  APPROPRIATE_AUDIO: 'This content could be considered sensitive by others.',
  APPROPRIATE_COURSE: 'This content could be considered sensitive by others.',
  SIZE_OF_PREVIEW_IMAGE:
    'Width of image should be greater than 450 pixels and height of image should be greater than 200 pixels.',
  APPROPRIATE_CONTENT_HINT:
    'It is your responsibility as a creator to determine if a piece of content could offend or upset others. If you are not sure, we recommend checking this option and it will overlay a warning to users before they see it.',
  ADD_WATERMARK_TO_IMAGES: 'Add Watermark to Images',
  ADD_WATERMARK_TO_VIDEOS: 'Add Watermark to Videos',
  ADD_WATERMARK_TO_REELS: 'Add Watermark to Reels',
  IMAGE_FILE_SIZE_LIMIT: 'You cannot upload image size more than 5 MB.',
};
export const MODAL_MESSAGES = {
  ACCEPTABLE_USE_POLICY_1:
    'Your content can still be posted, so long that it follows the ',
  ACCEPTABLE_USE_POLICY_2: `${environment.websiteURL}terms-conditions`,
  ACCEPTABLE_USE_POLICY_3:
    '. It will not show in the Discovery Feed or to users under the age of 18 but will show in your own Content Feed with a Sensitive Content warning and overlay.',
  CHATROOM_ACCEPTABLE_USE_POLICY_3:
    '. It will not show to users under the age of 18 but will show in your Chatroom Feed with a Sensitive Content warning and overlay.',

  NON_VIOLATE_POLICY_TEXT: 'I Agree',
  TERM_AND_CONDITION: 'Acceptable Use Policy',
  POLICY: 'Sensitive Content Policy'
};
export const FEED_MESSAGES = {
  SENSITIVE_CONTENT_ADIVORY: 'Sensitive Content Advisory',
  POST_HAVE_VIOLENCE_NUDITY:
    'The creator of this post has indicated that it may contain content that could be considered sensitive for some users.',
  CHAT_ROOM_POST_HAVE_VIOLENCE_NUDITY:
    'The creator of this chatroom post has indicated that it may contain content that could be considered sensitive for some users.',
  COURSE_HAVE_VIOLENCE_NUDITY:
    'The creator of this course has indicated that it may contain content that could be considered sensitive for some users.'
};
export const POST_TYPE = {
  REELS: 'reel',
  GIVEAWAY: 'giveaway',
  ARTICLE: 'article',
  LIVE_STREAM: 'livestream'
};

export const LOCKED_POST_MESSAGES = {
  LOCKED: 'Locked',
  SUBSCRIBE_TO_SEE_POST: 'Subscribe to See Post',
  SUBSCRIBE_TO_LISTEN: 'Subscribe to Listen',
  OR: 'or',
  PAY: 'Pay',
  TO_VIEW: 'to View',
  TO_LISTEN: 'to Listen',
  UNLOCK_WITH_NFT: 'Unlock with NFT',
  UNLOCK_WITH_NFT_CAPS: 'Unlock With NFT',
  COLLAB: 'Collab',
  UNLOCK_POST_LOYALTY_PREFIX: 'Unlock with',
  UNLOCK_POST_WITH_POINTS_MODAL_HEADER: 'Unlock Post with Points',
  CONTENT_UNLOCKED_WITH_LOYALTY_POINTS: 'Content Unlocked with Points',
  SIGN_IN_REQUIRED: 'Sign In Required'
};

export const UNDER_18 = {
  RESTRICTION_OF_UNAPPROPRIATE_CONTENT:
    'You must be 18 or older to post sensitive or inappropriate content. Your account is restricted from sharing this type of content due to age restrictions.'
};

export const getPostPriceTextAreaField = () => {
  const fields: Field = {
    name: 'description',
    label: '',
    maxlength: 500,
    type: fieldTypes.TEXT_AREA,
    class: 'col-12'
  };
  return fields;
};

export const consentCheckbox = {
  type: fieldTypes.CHECKBOX,
  label: '',
  placeholder: '',
  name: 'archive_post',
  class: 'col-12',
  options: [
    {
      label: NEW_POST_CONST.ARCHIVE_VIDEO_POST,
      value: HOME_STRING.YES
    }
  ],
  labelKey: 'label',
  valueKey: 'value',
  infoIconMessageCls: 'ml-0'
};

export const enableCommentCheckbox = {
  type: fieldTypes.CHECKBOX,
  label: '',
  placeholder: '',
  name: 'is_comment_enable',
  class: 'col-12',
  options: [
    {
      label:'Enable Livestream Comments',
      value: HOME_STRING.YES
    }
  ],
  labelKey: 'label',
  valueKey: 'value',
};

export const enableSendTipCheckbox = {
  type: fieldTypes.CHECKBOX,
  label: '',
  placeholder: '',
  name: 'accept_tip_on_livestream',
  class: 'col-12',
  options: [
    {
      label:'Accept Livestream Tips',
      value: HOME_STRING.YES
    }
  ],
  labelKey: 'label',
  valueKey: 'value',
};
